import { BlurView } from "expo-blur";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import {
  Platform,
  Pressable,
  StyleSheet,
  View,
  type StyleProp,
  type ViewStyle,
} from "react-native";

type BlurredBackdropProps = {
  accessibilityLabel?: string;
  disabled?: boolean;
  onPress?: () => void;
  style?: StyleProp<ViewStyle>;
};

export function BlurredBackdrop({
  accessibilityLabel,
  disabled = false,
  onPress,
  style,
}: BlurredBackdropProps) {
  useTranslation();

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={
        accessibilityLabel ?? i18n.t("profile.validation.closePopup")
      }
      disabled={disabled || !onPress}
      onPress={onPress}
      style={[StyleSheet.absoluteFill, style]}
    >
      {Platform.OS === "web" ? (
        <>
          <BlurView
            intensity={18}
            tint="dark"
            style={StyleSheet.absoluteFill}
          />
          <View pointerEvents="none" style={styles.webScrim} />
        </>
      ) : (
        <View pointerEvents="none" style={styles.nativeScrim} />
      )}
    </Pressable>
  );
}

const styles = StyleSheet.create({
  // No blur on native — expo-blur is only dependable on web here — so the
  // scrim alone must do the separating. It has to stay TRANSLUCENT: an opaque
  // theme-background fill made every native sheet look like the screen behind
  // it had been wiped (the group chat "disappeared" under its own menu).
  // Same dim as the Conversation Practice sheet, the reference behaviour.
  nativeScrim: {
    ...StyleSheet.absoluteFill,
    backgroundColor: "rgba(8, 15, 26, 0.55)",
  },
  webScrim: {
    ...StyleSheet.absoluteFill,
    backgroundColor: "rgba(6, 18, 36, 0.18)",
  },
});
